import React from 'react'
import { Link } from '@tanstack/react-router'

interface EventlyAccountNoticeProps {
  variant?: 'login' | 'signup'
}

const EventlyAccountNotice: React.FC<EventlyAccountNoticeProps> = ({ variant = 'login' }) => {
  const getMessage = () => {
    if (variant === 'login') {
      return {
        prefix: "Use your existing credentials to ",
        linkText: "sign in here",
        suffix: "."
      }
    } else {
      return {
        prefix: "You can use your existing credentials to ",
        linkText: "sign in",
        suffix: " instead of creating a new account."
      }
    }
  }

  const message = getMessage()

  return (
    <div className="mb-6 p-4 bg-orange-50 border border-orange-200 rounded-lg">
      <div className="flex items-center">
        <div className="w-5 h-5 bg-orange-500 rounded-full flex items-center justify-center mr-3">
          <span className="text-white text-xs font-bold p-2">i</span>
        </div>
        <p className="text-orange-800 text-sm">
          <strong>Already have an Evently account?</strong> {message.prefix}
          <Link 
            to="/login" 
            className="text-orange-600 hover:text-orange-700 underline font-medium"
          >
            {message.linkText}
          </Link>
          {message.suffix}
        </p>
      </div>
    </div>
  )
}

export default EventlyAccountNotice
